const planetFlagSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="28.333px" height="28.333px" viewBox="0 0 28.333 28.333" enable-background="new 0 0 28.333 28.333" xml:space="preserve">
<g>
	<g>
		<path fill="#4D5CA6" d="M24.184,17.762c-2.281-2.28-5.202-3.687-8.356-4.053V7.525h7.943c0.223,0,0.426-0.135,0.511-0.343
			s0.038-0.444-0.121-0.602l-2.277-2.265l2.277-2.264c0.159-0.157,0.206-0.396,0.121-0.603c-0.085-0.208-0.288-0.342-0.511-0.342
			h-8.039C15.503,0.461,14.888,0,14.167,0c-0.916,0-1.66,0.745-1.66,1.659v3.902c0,0.306,0.247,0.555,0.553,0.555
			c0.306,0,0.553-0.249,0.553-0.555V1.659c0-0.305,0.249-0.552,0.554-0.552c0.305,0,0.553,0.247,0.553,0.552v5.313v6.654
			c-0.184-0.008-0.368-0.014-0.553-0.014c-0.185,0-0.37,0.006-0.554,0.014v-3.417c0-0.305-0.248-0.553-0.553-0.553
			c-0.306,0-0.553,0.248-0.553,0.553v3.5c-3.156,0.366-6.077,1.772-8.358,4.053C1.473,20.438,0,23.995,0,27.78
			c0,0.305,0.248,0.553,0.553,0.553c0.305,0,0.553-0.248,0.553-0.553c0-2.485,0.698-4.809,1.906-6.789c0.006,0,0.012,0,0.019,0
			c1.719,0,3.117,1.398,3.117,3.119c0,0.92-0.403,1.787-1.106,2.381c-0.233,0.197-0.263,0.546-0.067,0.78
			c0.11,0.129,0.268,0.197,0.425,0.197c0.126,0,0.252-0.045,0.355-0.132c0.954-0.805,1.5-1.982,1.5-3.227
			c0-2.094-1.53-3.835-3.531-4.167c2.385-3.171,6.179-5.224,10.442-5.224c2.598,0,5.021,0.762,7.057,2.076
			c-1.687,0.245-2.987,1.699-2.987,3.453c0,1.923,1.565,3.488,3.489,3.488c1.749,0,3.201-1.292,3.452-2.973
			c1.296,2.028,2.048,4.436,2.048,7.016c0,0.305,0.249,0.553,0.555,0.553c0.304,0,0.553-0.248,0.553-0.553
			C28.333,23.995,26.86,20.438,24.184,17.762z M15.827,2.212h6.602l-1.721,1.711c-0.104,0.104-0.163,0.246-0.163,0.392
			s0.058,0.289,0.163,0.393l1.721,1.71h-6.602V2.212z M21.726,22.631c-1.313,0-2.382-1.069-2.382-2.382
			c0-1.314,1.069-2.383,2.382-2.383c1.314,0,2.383,1.069,2.383,2.383C24.109,21.562,23.041,22.631,21.726,22.631z"/>
	</g>
</g>
</svg>

`;

export default planetFlagSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/planetFlagSVG.js